/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

module.exports = { 
  typography: ["headline-3xl","headline-2xl","headline-xl","headline-lg","headline-md","headline-sm","headline-xs","headline-2xs","headline-alternative-3xl","headline-alternative-2xl","headline-alternative-xl","headline-alternative-lg","headline-alternative-md","headline-alternative-sm","headline-alternative-xs","headline-alternative-2xs","preheadline-md","preamble-md","preamble-sm","body-md","body-sm"],
  prose: ["factbox","coverbox"],
};